import script from "./ListUsers.vue?vue&type=script&lang=ts&setup=true"
export * from "./ListUsers.vue?vue&type=script&lang=ts&setup=true"

import "./ListUsers.vue?vue&type=style&index=0&id=28b07ed4&lang=scss"

export default script